import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { CircularProgressStyle } from './styles';
import { RcCircularProgressClasses } from './utils';
var _RcCircularProgress = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcCircularProgress' });
    var classesProp = props.classes, color = props.color, rest = __rest(props, ["classes", "color"]);
    var classes = useMemo(function () { return combineClasses(RcCircularProgressClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiCircularProgress, __assign({}, rest, { color: "inherit", ref: ref, classes: classes })));
});
var RcCircularProgress = styled(_RcCircularProgress)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CircularProgressStyle);
RcCircularProgress.defaultProps = {
    size: 24,
    color: 'interactive.f01',
};
RcCircularProgress.displayName = 'RcCircularProgress';
export { RcCircularProgress };
var templateObject_1;
